<ng-container *ngIf="open">
  <div
    class="admin-modal-overlay active"
    (click)="onBackdropClick()"
  ></div>
  <div
    class="admin-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="edit-org-budget-title"
  >
    <div class="admin-modal-header">
      <h3 id="edit-org-budget-title">Edit AI Usage Budget</h3>
      <button
        type="button"
        class="admin-modal-close"
        aria-label="Close"
        [disabled]="isSaving"
        (click)="onClose()"
      >
        &times;
      </button>
    </div>
    <form (ngSubmit)="onSave()" #budgetForm="ngForm">
      <div class="admin-modal-body">
        <label class="admin-modal-field">
          <span class="admin-modal-label">Lifetime budget cap (USD)</span>
          <input
            type="number"
            min="0"
            step="0.01"
            name="capUsd"
            class="admin-modal-input"
            [(ngModel)]="capUsdInput"
            [disabled]="isSaving"
          />
        </label>
        <p *ngIf="errorMessage" class="edit-org-budget-modal__error" role="alert">
          {{ errorMessage }}
        </p>
      </div>
    </form>
    <div class="admin-modal-footer">
      <saffron-button
        text="Cancel"
        type="secondary"
        size="small"
        [is_disabled]="isSaving"
        (click)="onClose()"
      ></saffron-button>
      <saffron-button
        [text]="isSaving ? 'Saving…' : 'Save'"
        type="primary"
        size="small"
        [is_disabled]="isSaving || capUsdInput == null || capUsdInput < 0"
        [is_loading]="isSaving"
        (click)="onSave()"
      ></saffron-button>
    </div>
  </div>
</ng-container>
